// @flow
import { ServiciosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    servicio: {},
    listaServicios: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type ServiciosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { servicio?: {} | null, listaServicios?: [] | null, loading?: boolean, +value ?: boolean };

const Servicios = (state: State = INIT_STATE, action: ServiciosAction): any => {
    // console.log(action);
    switch (action.type) {
        case ServiciosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ServiciosActionTypes.GET_SERVICIO: {
                    return {
                        ...state,
                        servicio: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ServiciosActionTypes.LIST_SERVICIOS: {
                    return {
                        ...state,
                        listaServicios: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ServiciosActionTypes.ADD_SERVICIO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ServiciosActionTypes.UPDATE_SERVICIO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ServiciosActionTypes.DELETE_SERVICIO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ServiciosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ServiciosActionTypes.GET_SERVICIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        servicio: {},
                        loading: false,
                    };
                }
                case ServiciosActionTypes.LIST_SERVICIOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaServicios: [],
                        loading: false,
                    };
                }
                case ServiciosActionTypes.ADD_SERVICIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ServiciosActionTypes.UPDATE_SERVICIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case ServiciosActionTypes.DELETE_SERVICIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ServiciosActionTypes.GET_SERVICIO:
            return { ...state, error: false, loading: true };
        case ServiciosActionTypes.LIST_SERVICIOS:
            return { ...state, error: false, loading: true };
        case ServiciosActionTypes.ADD_SERVICIO:
            return { ...state, error: false, loadingForm: true };
        case ServiciosActionTypes.UPDATE_SERVICIO:
            return { ...state, error: false, loadingForm: true };
        case ServiciosActionTypes.DELETE_SERVICIO:
            return { ...state, error: false, loading: true };
        case ServiciosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                servicio: {},
                listaServicios: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Servicios;
